"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get GetBaseSearchServiceResponse () {
        return GetBaseSearchServiceResponse;
    },
    get GetBaseSearchServiceResponseCsv () {
        return GetBaseSearchServiceResponseCsv;
    }
});
const _zod = require("zod");
const _helpers = require("./helpers");
const GetBaseSearchServiceResponse = _zod.z.object({
    errors: _zod.z.array(_zod.z.string()),
    warnings: _zod.z.array(_zod.z.string()),
    results: _zod.z.array(_zod.z.any()),
    total: _zod.z.number(),
    debug: _helpers.debugSchema.optional()
});
const GetBaseSearchServiceResponseCsv = _zod.z.object({
    errors: _zod.z.array(_zod.z.string()),
    warnings: _zod.z.array(_zod.z.string()),
    jobID: _zod.z.string(),
    debug: _helpers.debugSchema.optional()
});
